module.exports = __webpack_public_path__ + "img/18.438ffc0c.png";